// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"75ed27b2","787":"2308ae64"}[chunkId] + ".chunk.js";
};